"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeStringify = exports.speedOfLoadChunk = exports.sumLoadChunks = exports.nullOrValue = exports.delay = void 0;
const R = __importStar(require("ramda"));
function delay(ms) {
    return new Promise(resolve => setTimeout(() => resolve(), ms));
}
exports.delay = delay;
function nullOrValue(value) {
    return R.isNil(value) ? null : value;
}
exports.nullOrValue = nullOrValue;
function sumLoadChunks(values) {
    return {
        byteCount: R.sum(values.map(v => v.byteCount)),
        duration: R.sum(values.map(v => v.duration))
    };
}
exports.sumLoadChunks = sumLoadChunks;
function speedOfLoadChunk(chunk) {
    return chunk.duration > 0 ? chunk.byteCount * 8 / chunk.duration : 0;
}
exports.speedOfLoadChunk = speedOfLoadChunk;
const safeStringify = (obj) => {
    if (R.isNil(obj)) {
        return "";
    }
    try {
        return JSON.stringify(obj, null, 2);
    }
    catch (err) {
        return "<stringify error>";
    }
};
exports.safeStringify = safeStringify;
//# sourceMappingURL=utils.js.map